var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},_vm._l((_vm.mapArr),function(row,index){return _c('ul',{key:index,staticClass:"row"},_vm._l((row),function(item,i){return _c('li',{key:i,staticClass:"item",class:_vm.getClass(item)})}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-657667ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Map.vue
// module id = 2h37
// module chunks = 0